import { css, html, LitElement, nothing } from "lit";
import { windowsMePrimitives } from "../shared/windows-me-styles";

export class LightDomAppHost extends LitElement {
	static properties = {
		accessibleLabel: { type: String, attribute: "accessible-label" },
		busy: { type: Boolean },
		emptyMessage: { type: String, attribute: "empty-message" },
	};

	static styles = [
		windowsMePrimitives,
		css`
			:host {
				display: block;
				min-block-size: 120px;
			}

			.app-host__mount {
				display: block;
				min-block-size: inherit;
			}

			.app-host__placeholder {
				display: grid;
				place-items: center;
				min-block-size: 120px;
				padding: 12px;
				color: var(--shell-text-muted);
				font: 400 11px/1.35 var(--shell-font);
				text-align: center;
			}
		`,
	];

	accessibleLabel = "Application host";

	busy = false;

	emptyMessage = "";

	createRenderRoot() {
		return this;
	}

	get mountElement() {
		return this.querySelector<HTMLElement>("[data-app-mount]");
	}

	render() {
		const showPlaceholder =
			!this.mountElement?.childElementCount && this.emptyMessage;
		return html`
			<div
				class="app-host__mount"
				part="mount"
				data-app-mount
				role="group"
				aria-label=${this.accessibleLabel}
				aria-busy=${this.busy ? "true" : "false"}
			></div>
			${
				showPlaceholder
					? html`<p class="app-host__placeholder">${this.emptyMessage}</p>`
					: nothing
			}
		`;
	}
}

if (!customElements.get("light-dom-app-host")) {
	customElements.define("light-dom-app-host", LightDomAppHost);
}
